import React from 'react';
import { IGlobalVariable } from '../Interfaces/IGlobalVariable';
import { Alert, Grid, Typography } from '@mui/material';
import { CustomeTextField } from '../generic/CustomeTextField';

interface IProps {
  editGlobalVariable: IGlobalVariable;
  setEditGlobalVariable: React.Dispatch<
    React.SetStateAction<IGlobalVariable | null>
  >;
}

export const GlobalVariableEdit: React.FC<IProps> = ({
  editGlobalVariable,
  setEditGlobalVariable,
}) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity='info'>
            <Typography>
              Bitte achten Sie darauf, dass die Groß- und Kleinschreibung der
              Variablen korrekt eingehalten werden muss. Für die
              Namenskonvention wird empfohlen, auf Sonderzeichen (Ausnahme: _)
              sowie Umlaute möglichst zu verzichten. Wenn Sie beispielsweise
              einen Link zur Google-Bewertung als Variable hinterlegen möchten,
              empfiehlt es sich, die Variable <i>google_rating_link</i> zu
              benennen. Auf diese können Sie anschließend über{' '}
              <i>{`{{google_rating_link}}`}</i> zugreifen.
            </Typography>
          </Alert>
        </Grid>

        <Grid item xs={6}>
          <CustomeTextField
            label='Variable'
            attr='GlobalVariable'
            object={editGlobalVariable}
            setObject={setEditGlobalVariable}
            type='string'
            required
          />
        </Grid>
        <Grid item xs={6}>
          <CustomeTextField
            label='Wert'
            attr='VariableValue'
            object={editGlobalVariable}
            setObject={setEditGlobalVariable}
            rows={3}
            type='string'
            required
          />
        </Grid>
      </Grid>
    </>
  );
};
